/* eslint-disable react/no-array-index-key */
import classNames from 'classnames';
import isEmpty from 'lodash/isEmpty';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import { FormattedMessage } from 'react-intl';

import styles from '../../../styles/partials/film-details.module.css';

const propTypes = {
    film: PropTypes.shape({}),
    className: PropTypes.string,
};

function FilmDetails({ film = null, className }) {
    const {
        languages = [],
        subtitleLanguages = [],
        producers = [],
        distributors = [],
        categories = [],
        themes = [],
        prizes = [],
    } = film || {};

    const filmLanguages = useMemo(
        () =>
            (languages || [])
                .map(({ label = null }) => label)
                .filter((str) => !isEmpty(str))
                .join(', '),
        [languages],
    );

    const filmSubtitleLanguages = useMemo(
        () =>
            (subtitleLanguages || [])
                .map(({ label = null }) => label)
                .filter((str) => !isEmpty(str))
                .join(', '),
        [subtitleLanguages],
    );

    const filmProducers = useMemo(
        () =>
            (producers || [])
                .map(({ name = null }) => name)
                .filter((str) => !isEmpty(str))
                .join(', '),
        [producers],
    );

    const filmDistributors = useMemo(
        () =>
            (distributors || [])
                .map(({ name = null }) => name)
                .filter((str) => !isEmpty(str))
                .join(', '),
        [distributors],
    );

    const filmCategories = useMemo(
        () =>
            (categories || [])
                .map(({ label = null }) => label)
                .filter((str) => !isEmpty(str))
                .join(', '),
        [categories],
    );

    const filmThemes = useMemo(
        () =>
            (themes || [])
                .map(({ label = null }) => label)
                .filter((str) => !isEmpty(str))
                .join(', '),
        [categories],
    );

    const filmPrizes = useMemo(
        () =>
            (prizes || [])
                .map(
                    ({ title = null, festival = null, year = null }) =>
                        `${title} (${festival !== null ? `${festival}, ` : ''}${year})`,
                )
                .filter((str) => !isEmpty(str))
                .join(', '),
        [categories],
    );

    return (
        <div className={classNames([styles.container, { [className]: className !== null }])}>
            <ul className={styles.list}>
                <li
                    className={classNames({
                        [styles.split]: !isEmpty(filmLanguages) && !isEmpty(filmSubtitleLanguages),
                    })}
                >
                    {!isEmpty(filmLanguages) ? (
                        <div className={styles.section}>
                            <FormattedMessage
                                defaultMessage="Language : {value}"
                                description="List label"
                                values={{ value: filmLanguages }}
                            />
                        </div>
                    ) : null}
                    {!isEmpty(filmSubtitleLanguages) ? (
                        <div className={styles.section}>
                            <FormattedMessage
                                defaultMessage="Subtitles : {value}"
                                description="List label"
                                values={{ value: filmSubtitleLanguages }}
                            />
                        </div>
                    ) : null}
                </li>
                <li
                    className={classNames({
                        [styles.split]: !isEmpty(filmProducers) && !isEmpty(filmDistributors),
                    })}
                >
                    {!isEmpty(filmProducers) ? (
                        <div className={styles.section}>
                            <FormattedMessage
                                defaultMessage="Production : {value}"
                                description="List label"
                                values={{ value: filmProducers }}
                            />
                        </div>
                    ) : null}
                    {!isEmpty(filmDistributors) ? (
                        <div className={styles.section}>
                            <FormattedMessage
                                defaultMessage="Distribution : {value}"
                                description="List label"
                                values={{ value: filmDistributors }}
                            />
                        </div>
                    ) : null}
                </li>
                {!isEmpty(filmCategories) ? (
                    <li>
                        <div className={styles.section}>
                            <FormattedMessage
                                defaultMessage="Categories : {value}"
                                description="List label"
                                values={{ value: filmCategories }}
                            />
                        </div>
                    </li>
                ) : null}
                {!isEmpty(filmThemes) ? (
                    <li>
                        <div className={styles.section}>
                            <FormattedMessage
                                defaultMessage="Themes : {value}"
                                description="List label"
                                values={{ value: filmThemes }}
                            />
                        </div>
                    </li>
                ) : null}
                {!isEmpty(filmPrizes) ? (
                    <li>
                        <div className={styles.section}>
                            <FormattedMessage
                                defaultMessage="Distinctions : {value}"
                                description="List label"
                                values={{ value: filmPrizes }}
                            />
                        </div>
                    </li>
                ) : null}
            </ul>
        </div>
    );
}

FilmDetails.propTypes = propTypes;

export default FilmDetails;
